import tsRest from 'ts-rest-client';
import { VenueSeatAvailabilityReportModel } from './models/venue-seat-availability-report-model';

/**
 * 
 * @param apiBaseUrl FOR THIS SPECIFIC KIND OF ROUTE ONLY. For seat related routes, we call the rest api through the legacy url to take advantage of the same caching because venu plans are big as hell and to get the latest in-memory seat updates too. Can be gotten from tsapp.getRESTAPIThroughLegacyUrl()
 * @param eventDateId 
 * @returns 
 */
export async function getEventDateAvailableSeatsReport(baseAPIUrl: string, eventDateId: number): Promise<VenueSeatAvailabilityReportModel> {
    return tsRest.get(`/data/eventdates/${eventDateId}/availableseats`, { baseAPIUrl: baseAPIUrl});
}

/**
 * 
 * @param apiBaseUrl FOR THIS SPECIFIC KIND OF ROUTE ONLY. For seat related routes, we call the rest api through the legacy url to take advantage of the same caching because venu plans are big as hell and to get the latest in-memory seat updates too. Can be gotten from tsapp.getRESTAPIThroughLegacyUrl()
 * @param eventDateId 
 * @returns 
 */
export async function getPackageAvailableSeatsReport(baseAPIUrl: string, packageId: number, mainEventDateId: number, selectedEventDateIds: number[] = null): Promise<VenueSeatAvailabilityReportModel> {
    const queryParams: string[] = [];
    if(selectedEventDateIds) queryParams.push(`eventdateids=${selectedEventDateIds.join(',')}`);
    if(mainEventDateId) queryParams.push(`maineventdateid=${mainEventDateId}`);
    const queryStr = queryParams.length > 0 ? "?" + queryParams.join('&') : "";
    return tsRest.get(`/data/packages/${packageId}/availableseats${queryStr}`, { baseAPIUrl: baseAPIUrl});
}